import forEachObjIndexed from 'ramda/src/forEachObjIndexed';
import { isArray } from 'rxjs/internal-compatibility';

/**
 * Adds an array parameter to a URL, that is
 * {
 *   key: [value, value1, value2, ...]
 * }
 * would add ?key=value&key=value1&key=value2&key=...
 * @param key
 * @param value
 * @param url
 */
const addArrayParamToUrl = (key: string, value: any[], url: string): string => {
  return value.reduce(
    (previousValue: string, keyValue: any): string =>
      previousValue.includes('?')
        ? `${previousValue}&${key}=${keyValue}`
        : `${previousValue}?${key}=${keyValue}`,
    url,
  );
};

/**
 * Extract array parameters from a params object and properly add them to the URL.
 * We need this because if we pass array parameters to the controller, it will add
 * ?key=[value1, value2, ...] to the URL, rather than
 * ?key=value1&key=value2&key=... like we would want.
 * @param url
 * @param params
 */
export const extractArrayParams = (
  url: string,
  params?: any,
): { url: string; params?: { [key: string]: string } } => {
  if (params) {
    let newUrl = url;
    const newParams = Object.assign({}, params);
    const arrayParams: string[] = [];
    forEachObjIndexed((value: any, key: string | number | symbol) => {
      if (isArray(value)) {
        arrayParams.push(typeof key === 'string' ? key : key.toString());
      }
    }, params);
    if (arrayParams.length) {
      arrayParams.forEach((key: string) => {
        newUrl = addArrayParamToUrl(key, params[key], newUrl);
        delete newParams[key];
      });
    }
    return { url: newUrl, params: newParams };
  }
  return { url, params };
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/controller/utils.ts